import React from 'react'

const Center = ({children}) => {
    return (
        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
            {children}
        </div>
    )
}

export default Center
